import { InputEntity } from "../../..";

export class TransmedRegistrationContestationAskInput extends InputEntity {
  public constructor(public question: string) {
    super();
  }
}

export class TransmedRegistrationContestationAnswerInput extends InputEntity {
  public constructor(public answer: string) {
    super();
  }
}
